
  import { getLiveClickIds } from '@/utils/clickIds';

  export default {
    props: {
      showSkip: {
        default: 'true',
        type: String,
      },
    },
    data() {
      return {
        showCover: true,
        showLeadForm: false,
        showResult: false,
        answerList: [],
        questionMap: {
          q1: { text: 'Do you already have a TEFL qualification?', options: ['Yes', 'No'] },
          q10: { text: 'Are you looking to refresh an old qualification or top it up with advanced training?', options: ['Refresh an old qualification', 'Top up with advanced training'] },
          q2: { text: 'Where do you want to teach?', options: ['Online', 'Abroad', 'Not sure yet'] },
          q3: { text: 'In which part of the world do you want to teach?', options: ['Europe', 'Asia', 'Latin America', 'Middle East', 'Not sure'] },
          q4: { text: 'Do you have a degree?', options: ['Yes', 'No', 'Working towards one'] },
          q5: { text: 'Do you have previous teaching experience?', options: ['Yes', 'No'] },
          q6: { text: 'Are you a qualified teacher? (QTS, PGCE, PGDE, etc)', options: ['Yes', 'No'] },
          q7: { text: 'What sort of work are you looking for?', options: ['Full time', 'Part time', 'Voluntary'] },
          q8: { text: 'Would you like your training to include live classroom sessions?', options: ['Yes', 'No, I want it to be 100% self-paced'] },
          q9: { text: 'Would you prefer live sessions to be on weekends or weekdays?', options: ['Weekends', 'Weekdays'] },
          q11: { text: 'What age of students do you want to work with?', options: ['Children', 'Teenagers', 'Adults'] },
          q12: { text: 'Which age range are you?', options: ['18-24', '25-34', '35-44', '45-54', '55+'] }
        },
        currentQuestionId: 'q1',
        questionHistory: [],
        answers: {},
        loading: false,
        result: '',
        leadForm: {
          name: '',
          lastName: '',
          email: '',
          consent: true
        },
        isAre: 'is',
        standardOnlineLink: '/courses/online/120-hour-premier-online-tefl-course/',
        audioEditionLink: '/courses/online/120-hour-premier-online-tefl-course-audio-edition/', // TODO: confirm the real Audio Edition URL
      };
    },
    computed: {
      currentQuestion() {
        return this.currentQuestionId ? { id: this.currentQuestionId, ...this.questionMap[this.currentQuestionId] } : null;
      },
      resultImage() {
        const images = {
          '120-hour Premier Online TEFL course': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/120hr-quiz-result.jpg',
          '140-hour Premier TEFL course': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/140hr-quiz-result.jpg',
          '150-hour Premier TEFL course': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/150hr-quiz-result.jpg',
          '250-hour Level 5 Diploma': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/12/250-abroad.jpg',
          '270-hour Level 5 Diploma': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/12/270-abroad.jpg',
          '280-hour Level 5 Diploma': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/12/280-abroad.jpg',
          '250-hour Level 5 Diploma (Abroad)': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/12/250-abroad.jpg',
          '270-hour Level 5 Diploma (Abroad)': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/12/270-abroad.jpg',
          '280-hour Level 5 Diploma (Abroad)': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/12/280-abroad.jpg',
          '250-hour Level 5 Diploma (Online)': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/12/250-online.jpg',
          '270-hour Level 5 Diploma (Online)': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/12/270-online.jpg',
          '280-hour Level 5 Diploma (Online)': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/12/280-online.jpg',
          '140-hour Premier + 40-hour Teaching English Online courses': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/140hr-40hr-teo-quiz-result.jpg',
          '150-hour Premier + 40-hour Teaching English Online courses': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/150hr-40hr-teo-quiz-result.jpg',
          '120-hour Premier Online + 30-hour Teaching Young Learners courses': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/120hr-30hr-tyl-quiz-result.jpg',
          '120-hour Premier Online + 40-hour Exam Preparation courses': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/120hr-40hr-examprep-quiz-result.jpg',
          '120-hour Premier Online + 40-hour Business English courses': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/120hr-40hr-be-quiz-result.jpg',
          '30-hour Teaching Young Learners course': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/30hr-tyl-quiz-result.jpg',
          '40-hour Exam Preparation course': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/40hr-examprep-quiz-result.jpg',
          '30-hour Teaching Business English course': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/30hr-be-quiz-result.jpg',
          '30-hour Teaching Young Learners + 40-hour Teaching English Online courses': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/30hr-tyl-40hr-teo-quiz-result.jpg',
          '40-hour Exam Preparation + 40-hour Teaching English Online courses': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/40hr-examprep-40hr-teo-quiz-result.jpg',
          '30-hour Business English + 40-hour Teaching English Online courses': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/30hr-be-40hr-teo-quiz-result.jpg',
          'Contact us for a personalised recommendation': 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/quiz-cover.jpg'
        };
        return images[this.result] || 'https://cdn-wp.tefl.org/wp-content/uploads/2025/05/quiz-cover.jpg';
      },
      courseLink() {
        // Map result to a course page
        const links = {
          '120-hour Premier Online TEFL course': '/courses/online/120-hour-premier-online-tefl-course/',
          '140-hour Premier TEFL course': '/courses/combined/140-hour-premier-tefl-course/',
          '150-hour Premier TEFL course': '/courses/combined/150-hour-premier-tefl-course/',
          '250-hour Level 5 Diploma': '/courses/level-5/250-hour-online-level-5-tefl-course/',
          '270-hour Level 5 Diploma': '/courses/level-5/270-hour-level-5-tefl-course/',
          '280-hour Level 5 Diploma': '/courses/level-5/280-hour-level-5-tefl-course/',
          '250-hour Level 5 Diploma (Abroad)': '/courses/level-5/250-hour-online-level-5-tefl-course/',
          '270-hour Level 5 Diploma (Abroad)': '/courses/level-5/270-hour-level-5-tefl-course/',
          '280-hour Level 5 Diploma (Abroad)': '/courses/level-5/280-hour-level-5-tefl-course/',
          '250-hour Level 5 Diploma (Online)': '/courses/level-5/250-hour-online-level-5-tefl-course/',
          '270-hour Level 5 Diploma (Online)': '/courses/level-5/270-hour-level-5-tefl-course/',
          '280-hour Level 5 Diploma (Online)': '/courses/level-5/280-hour-level-5-tefl-course/',
          '140-hour Premier + 40-hour Teaching English Online courses': ['/courses/combined/140-hour-premier-tefl-course/','/courses/advanced/40-hour-teaching-english-online/'],
          '150-hour Premier + 40-hour Teaching English Online courses': ['/courses/combined/150-hour-premier-tefl-course/','/courses/advanced/40-hour-teaching-english-online/'],
          '120-hour Premier Online + 30-hour Teaching Young Learners courses': ['/courses/online/120-hour-premier-online-tefl-course/','/courses/advanced/30-hour-teaching-young-learners/'],
          '120-hour Premier Online + 40-hour Exam Preparation courses': ['/courses/online/120-hour-premier-online-tefl-course/','/courses/advanced/40-hour-teaching-exam-preparation-classes/'],
          '120-hour Premier Online + 40-hour Business English courses': ['/courses/online/120-hour-premier-online-tefl-course/','/courses/advanced/30-hour-teaching-business-english/'],
          '30-hour Teaching Young Learners course': '/courses/advanced/30-hour-teaching-young-learners/',
          '40-hour Exam Preparation course': '/courses/advanced/40-hour-teaching-exam-preparation-classes/',
          '30-hour Teaching Business English course': '/courses/advanced/30-hour-teaching-business-english/',
          '30-hour Teaching Young Learners + 40-hour Teaching English Online courses': ['/courses/advanced/30-hour-teaching-young-learners/','/courses/advanced/40-hour-teaching-english-online/'],
          '40-hour Exam Preparation + 40-hour Teaching English Online courses': ['/courses/advanced/40-hour-teaching-exam-preparation-classes/','/courses/advanced/40-hour-teaching-english-online/'],
          '30-hour Business English + 40-hour Teaching English Online courses': ['/courses/advanced/30-hour-teaching-business-english/','/courses/advanced/40-hour-teaching-english-online/'],
          'Contact us for a personalised recommendation': '/courses/'
        };
        return links[this.result] || '/courses/';
      },
      // True for any result containing the 120-hour Premier Online course
      // (standalone or in a combined bundle). Substring match keeps this robust
      // to the slightly inconsistent bundle naming in calculateResult().
      has120Premier() {
        return this.result.includes('120-hour Premier Online');
      },
      guideLink() {
        if (this.answers.q2 === 'Abroad') {
          return 'https://www.tefl.org/teach-english-abroad/';
        } else if (this.answers.q2 === 'Online') {
          return 'https://www.tefl.org/teach-english-online/';
        }
        // Fallback? Not sure which one here
        return 'https://www.tefl.org/teach-english-online/';
      },
      resultCourses() {
        // Split on ' + ' and trim
        const parts = this.result.split(' + ').map(str => str.trim());
        if (parts.length === 1) return parts;
        // Add 'course' to the first part if not present
        if (!/course(s)?$/.test(parts[0])) {
          parts[0] = parts[0].replace(/ courses?$/, '') + ' course';
        } else {
          parts[0] = parts[0].replace(/ courses$/, ' course');
        }
        // Remove trailing 's' from 'courses' in the last part
        parts[parts.length - 1] = parts[parts.length - 1].replace(/courses$/, 'course');
        return parts;
      },
    },
    methods: {
      startQuiz() {
        this.showCover = false;
        this.currentQuestionId = 'q1';
        this.questionHistory = [];
        this.answers = {};
        this.answerList = [];
        // Track via rudderstack
        this.$rs.track("Start Quiz", {
          form_name: 'quiz',
        }, {
          integrations: {
            "Klaviyo": false,
          },
        })
        // Track via GTM
        this.$gtm.push({
          event: 'start_quiz',
        });
      },
      selectOption(option) {
        this.answers[this.currentQuestionId] = option;
        this.answerList.push({ id: this.currentQuestionId, question: this.questionMap[this.currentQuestionId].text, answer: option });
        this.questionHistory.push(this.currentQuestionId);
        this.nextQuestion();
      },
      goBack() {
        if (this.questionHistory.length > 0) {
          this.currentQuestionId = this.questionHistory.pop();
          delete this.answers[this.currentQuestionId];
          this.answerList = this.answerList.filter(a => a.id !== this.currentQuestionId);
        }
      },
      
      nextQuestion() {
        const a = this.answers;
        const next = (id) => { this.currentQuestionId = id; };

        // Q1: Do you already have a TEFL qualification?
        if (!a.q1) return next('q1');

        // ===== Q1 == YES PATH =====
        if (a.q1 === 'Yes') {
          if (!a.q10) return next('q10'); // Refresh or Top up

          // Q10: Refresh path
          if (a.q10 === 'Refresh an old qualification') {
            if (!a.q2) return next('q2');
            if (a.q2 === 'Abroad' && !a.q3) return next('q3');
            if (!a.q4) return next('q4');
            if (!a.q5) return next('q5');
            if ((a.q2 === 'Abroad' || a.q2 === 'Not sure yet') && !a.q11) return next('q11');
            return this.finish();
          }

          // Q10: Top up path
          if (a.q10 === 'Top up with advanced training') {
            if (!a.q2) return next('q2');
            if (a.q2 === 'Abroad' && !a.q3) return next('q3');
            if (!a.q4) return next('q4');
            if (!a.q5) return next('q5');
            if (!a.q11) return next('q11');
            return this.finish();
          }
        }

        // ===== Q1 == NO PATH =====
        if (!a.q2) return next('q2');

        if (a.q2 === 'Online') {
          if (!a.q7) return next('q7');
          if (!a.q4) return next('q4');
          if (!a.q5) return next('q5');
          if (!a.q8) return next('q8');
          // q4 answer doesn't change navigation here, only the result
          if (a.q8.includes('No')) return this.finish();
          if (!a.q9) return next('q9');
          return this.finish();
        }

        if (a.q2 === 'Abroad' || a.q2 === 'Not sure yet') {
          if (!a.q3) return next('q3');
          if (!a.q7) return next('q7');
          if (!a.q4) return next('q4');
          if (!a.q5) return next('q5');
          if (a.q5 === 'Yes' && !a.q6) return next('q6');
          if (!a.q8) return next('q8');
          if (a.q8.includes('No')) return this.finish();
          if (!a.q9) return next('q9');
          return this.finish();
        }
      },

      // Every quiz path ends here. Ask the age range question last (asked to
      // everyone, doesn't affect the result), then work out the result.
      finish() {
        if (!this.answers.q12) {
          this.currentQuestionId = 'q12';
          return;
        }
        this.currentQuestionId = null;
        this.calculateResult();
      },

      calculateResult() {
        const a = this.answers;
        this.showLeadForm = true;
        this.showResult = false;

        // Q1 = Yes
        if (a.q1 === 'Yes') {
          // Q10 = Refresh
          if (a.q10 === 'Refresh an old qualification') {
            if (a.q2 === 'Abroad') {
              if (a.q11 === 'Children') {
                this.result = '120-hour Premier Online + 30-hour Teaching Young Learners courses';
                this.isAre = 'are'
                return;
              }
              if (a.q11 === 'Teenagers') {
                this.result = '120-hour Premier Online + 40-hour Exam Preparation courses';
                this.isAre = 'are'
                return;
              }
              if (a.q11 === 'Adults') {
                this.result = '120-hour Premier Online + 30-hour Teaching Business English courses';
                this.isAre = 'are'
                return;
              }
            }
            if (a.q2 === 'Online') {
              this.result = '120-hour Premier Online + 30-hour Teaching Young Learners courses';
              this.isAre = 'are'
              return;
            }
            if (a.q2 === 'Not sure yet') {
              if (a.q11 === 'Children') {
                this.result = '120-hour Premier Online + 30-hour Teaching Young Learners courses';
                this.isAre = 'are'
                return;
              }
              if (a.q11 === 'Teenagers') {
                this.result = '120-hour Premier Online + 40-hour Exam Preparation courses';
                this.isAre = 'are'
                return;
              }
              if (a.q11 === 'Adults') {
                this.result = '120-hour Premier Online + 30-hour Teaching Business English courses';
                this.isAre = 'are'
                return;
              }
            }
          }

          // Q10 = Top up
          if (a.q10 === 'Top up with advanced training') {
            if (a.q2 === 'Abroad') {
              if (a.q11 === 'Children') {
                this.result = '30-hour Teaching Young Learners course';
                return;
              }
              if (a.q11 === 'Teenagers') {
                this.result = '40-hour Exam Preparation course';
                return;
              }
              if (a.q11 === 'Adults') {
                this.result = '30-hour Teaching Business English course';
                return;
              }
            }
            if (a.q2 === 'Online') {
              if (a.q11 === 'Children') {
                this.result = '30-hour Teaching Young Learners + 40-hour Teaching English Online courses';
                this.isAre = 'are'
                return;
              }
              if (a.q11 === 'Teenagers') {
                this.result = '40-hour Exam Preparation + 40-hour Teaching English Online courses';
                this.isAre = 'are'
                return;
              }
              if (a.q11 === 'Adults') {
                this.result = '30-hour Business English + 40-hour Teaching English Online courses';
                this.isAre = 'are'
                return;
              }
            }
            if (a.q2 === 'Not sure yet') {
              if (a.q11 === 'Children') {
                this.result = '30-hour Teaching Young Learners + 40-hour Teaching English Online courses';
                this.isAre = 'are'
                return;
              }
              if (a.q11 === 'Teenagers') {
                this.result = '40-hour Exam Preparation + 40-hour Teaching English Online courses';
                this.isAre = 'are'
                return;
              }
              if (a.q11 === 'Adults') {
                this.result = '30-hour Business English + 40-hour Teaching English Online courses';
                this.isAre = 'are'
                return;
              }
            }
          }
        }

        // Q1 = No
        if (a.q1 === 'No') {
          // Q2 = Online
          if (a.q2 === 'Online') {
            if (a.q4 === 'Yes') {
              if (a.q8.includes("No")) {
                this.result = '120-hour Premier Online TEFL course';
                this.isAre = 'is'
                return;
              }
              if (a.q8 === 'Yes') {
                if (a.q9 === 'Weekends') {
                  this.result = '140-hour Premier + 40-hour Teaching English Online courses';
                  this.isAre = 'are'
                  return;
                }
                if (a.q9 === 'Weekdays') {
                  this.result = '150-hour Premier + 40-hour Teaching English Online courses';
                  this.isAre = 'are'
                  return;
                }
              }
            }
            if (a.q4 === 'No' || a.q4 === 'Working towards one') {
              if (a.q8.includes("No")) {
                this.result = '250-hour Level 5 Diploma (Online)';
                this.isAre = 'is'
                return;
              }
              if (a.q8 === 'Yes') {
                if (a.q9 === 'Weekends') {
                  this.result = '270-hour Level 5 Diploma (Online)';
                  this.isAre = 'is'
                  return;
                }
                if (a.q9 === 'Weekdays') {
                  this.result = '280-hour Level 5 Diploma (Online)';
                  this.isAre = 'is'
                  return;
                }
              }
            }
          }

          // Q2 = Abroad
          if (a.q2 === 'Abroad') {
            if (a.q4 === 'Yes') {
              if (a.q8.includes("No")) {
                this.result = '120-hour Premier Online TEFL course';
                this.isAre = 'is'
                return;
              }
              if (a.q8 === 'Yes') {
                if (a.q9 === 'Weekends') {
                  this.result = '140-hour Premier TEFL course';
                  this.isAre = 'is'
                  return;
                }
                if (a.q9 === 'Weekdays') {
                  this.result = '150-hour Premier TEFL course';
                  this.isAre = 'is'
                  return;
                }
              }
            }
            if (a.q4 === 'No' || a.q4 === 'Working towards one') {
              if (a.q8.includes("No")) {
                this.result = '250-hour Level 5 Diploma (Abroad)';
                this.isAre = 'is'
                return;
              }
              if (a.q8 === 'Yes') {
                if (a.q9 === 'Weekends') {
                  this.result = '270-hour Level 5 Diploma (Abroad)';
                  this.isAre = 'is'
                  return;
                }
                if (a.q9 === 'Weekdays') {
                  this.result = '280-hour Level 5 Diploma (Abroad)';
                  this.isAre = 'is'
                  return;
                }
              }
            }
          }

          // Q2 = Not sure yet
          if (a.q2 === 'Not sure yet') {
            if (a.q4 === 'Yes') {
              if (a.q8.includes("No")) {
                this.result = '120-hour Premier Online TEFL course';
                this.isAre = 'is'
                return;
              }
              if (a.q8 === 'Yes') {
                if (a.q9 === 'Weekends') {
                  this.result = '140-hour Premier TEFL course';
                  this.isAre = 'is'
                  return;
                }
                if (a.q9 === 'Weekdays') {
                  this.result = '150-hour Premier TEFL course';
                  this.isAre = 'is'
                  return;
                }
              }
            }
            if (a.q4 === 'No' || a.q4 === 'Working towards one') {
              if (a.q8.includes("No")) {
                this.result = '250-hour Level 5 Diploma';
                this.isAre = 'is'
                return;
              }
              if (a.q8 === 'Yes') {
                if (a.q9 === 'Weekends') {
                  this.result = '270-hour Level 5 Diploma';
                  this.isAre = 'is'
                  return;
                }
                if (a.q9 === 'Weekdays') {
                  this.result = '280-hour Level 5 Diploma';
                  this.isAre = 'is'
                  return;
                }
              }
            }
          }
        }

        // Fallback
        this.result = 'Contact us for a personalised recommendation';
      },

      async Submit() {

        // Prepare custom properties from quiz answers
        const a = this.answers;
        const properties = {
          'Quiz - Degree': a.q4 || '',
          'Quiz - Refresh or top up': a.q10 || '',
          'Quiz - Result': this.result || '',
          'Quiz - Student age': a.q11 || '',
          'Quiz - Teaching Experience': a.q5 || '',
          'Quiz - TEFL Qualification': a.q1 || '',
          'Quiz - Where': a.q2 || '',
          'Quiz - Which part of the world': a.q3 || '',
          'Quiz - Qualified Teacher': a.q6 || '',
          'Quiz - What sort of work': a.q7 || '',
          'Quiz - Live classroom sessions': a.q8 || '',
          'Quiz - Weekends or Weekdays': a.q9 || '',
          'Quiz - Age range': a.q12 || '',
        };

        console.log('Submit the form')
        this.loading = true
        console.log(this.form)
        const userId = this.userId
        const teflID = new URLSearchParams(window.location.search).get(
          "teflid"
        );
        const dataToSend = {
          email: this.leadForm.email, 
          campaign: 'Quiz', 
          merge_vars: this.leadForm, 
          props: properties
        }

        if(teflID) { // check if teflid parameter is set to anything
          dataToSend.referrer = teflID
        } else {
            const teflID2 = localStorage.getItem('tefl_teflid');
            if(teflID2) { // check if teflid parameter is set to anything
              dataToSend.referrer = teflID2
            }
        }

        // CLICK IDS — every live one, from the shared util. Listing them here
        // individually is how msclkid came to be captured, stored and never sent.
        const ids = getLiveClickIds();
        Object.assign(dataToSend, ids);
        dataToSend.click_ids = ids;

        // TOUCHPOINTS — capture the journey at lead creation time
        try {
          const touchpoints = JSON.parse(localStorage.getItem('tefl_touchpoints'));
          if (touchpoints && touchpoints.length) dataToSend.touchpoints = touchpoints;
        } catch (e) {
          console.warn('Could not parse touchpoints from localStorage');
        }

        const result = await this.$axios
        .$post(
          `${process.env.DATA_URL}/klaviyo/automations/quiz/send`,
              dataToSend
          )
          /*
          .$post(
            `${process.env.DATA_URL}/mailchimp/automations/form_request/send`,
              dataToSend
          )
          */
          .catch((error) => {
            console.log('Error', error)
          })
        
        console.log('got', result)
      

        if (result.statusCode === 204) {
          
          if ( window ) {

            // Identify via plugin
            this.$rs.identify(this.leadForm.email, {
              ...(this.userId !== "" ? {userId}: {}),
              name: this.leadForm.FNAME + ' ' + this.leadForm.LNAME,
              email: this.leadForm.email,
            }, {
              integrations: {
                "Klaviyo": false,
              },
            })
            // Track via rudderstack
            this.$rs.track("Generate Lead", {
              form_name: 'quiz',
            }, {
              integrations: {
                "Klaviyo": false,
              },
            })
            // Track via GTM
            this.$gtm.push({
              event: 'generate_lead',
              form_name: 'quiz',
              enhanced_conversion_data: {
                  "email": this.leadForm.email
              },
              user_data: {
                "email": this.leadForm.email
              }
            });
            
          }
          console.log('emit success')
          this.$emit("success")

          // alert(`Thanks, ${this.leadForm.name}! We’ll be in touch at ${this.leadForm.email}.`);
          this.showLeadForm = false;
          this.showResult = true;
        }

      },

      skipLeadForm() {
        this.showLeadForm = false;
        this.showResult = true;
      },
    }
  };
  